var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFlashOn = function SvgIcFlashOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.646 4.396c.508-.635 1.528-.197 1.417.608l-1.07 7.747 3.736-.614c.723-.118 1.212.717.755 1.29l-8.13 10.177c-.507.635-1.528.196-1.417-.61l1.07-7.748-3.736.616c-.723.119-1.212-.717-.755-1.29z"
  })));
};
export default SvgIcFlashOn;